<template>
  <div class="cailiao">
    <div id="cesiumContainer"></div>
  </div>
</template>

<script>

import { deviceArr} from '@/assets/js/device'
export default {
  data() {
    return {
    }
  },
  components: {},
  props: {
    bridgeObj: {
      type: Object,
      default: {}
    }
  },
  watch: {
    bridgeObj: {
      deep: true,
      handler() {
        if (this.bridgeObj.bridgeName == '新安江大桥') {
          this.open()
          this.gitBimlist()
        }
      }
    },
    bimData: {
      deep: true,
      handler() {}
    }
  },
  mounted() {
    this.open()
    this.gitBimlist()
    var viewer = new Cesium.Viewer('cesiumContainer');
    console.log('%c [ deviceArr ]-24', 'font-size:13px; background:pink; color:#bf2c9f;', deviceArr)
    viewer.imageryLayers.addImageryProvider(new Cesium.BingMapsImageryProvider({
            url : 'https://dev.virtualearth.net',
            mapStyle : Cesium.BingMapsStyle.AERIAL,
            key : 'AgYCj_VzN0MWJ-4pgJj3I7bZym9kmbb-HDWjG5cgHFJxNOokbRcSEtUwJM3uWweh'
        }));
    viewer.scene.open("https://supermap.51wephone.cn/iserver/services/3D-wc/rest/realspace");
    deviceArr.map(item=>{
      viewer.entities.add({
          id:item.bridgeName,
          position: Cesium.Cartesian3.fromDegrees(parseFloat(item.longitude), parseFloat(item.latitude), parseFloat(item.height)),
          // billboard:{
          //   image: require('@/assets/image/layout/addr-orange.png'),
          //   width:30,
          //   height:40,
          // },
          point:new Cesium.PointGraphics ( {
              show : true,
              pixelSize :  5,
              heightReference : Cesium.HeightReference.NONE,
              color : new Cesium.Color ( 255 , 255 , 0 , 1 ),
              outlineColor : new Cesium.Color ( 0 , 0 , 0 , 0 ),
              outlineWidth : 0,
              scaleByDistance : new Cesium.NearFarScalar ( 0 , 1 , 5e10 , 1 ),
              translucencyByDistance : new Cesium.NearFarScalar ( 0 , 1 , 5e10 , 1 ),
              distanceDisplayCondition : new Cesium.DistanceDisplayCondition(0, 4.8e10),
          } ),
          name: item.bridgeName,
          description: item.bridgeName
      });
    })
    viewer.zoomTo(viewer.entities)
    var handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
        handler.setInputAction(function(movement) {
          var pick = viewer.scene.pick(movement.position);
          if(Cesium.defined(pick) ) {
            alert('picked!');
            console.log('%c [ pick.id.id ]-60', 'font-size:13px; background:pink; color:#bf2c9f;', pick.id.id)
          }
        },Cesium.ScreenSpaceEventType.LEFT_CLICK);

        // 鼠标移入labelEntity提示框
        handler.setInputAction(function(movement) {

          var foundPosition = false;

          if (viewer.scene.mode !== Cesium.SceneMode.MORPHING) {
            var pickedObject = viewer.scene.pick(movement.endPosition);
            if(Cesium.defined(pickedObject) && (pickedObject.id.id === 'obj_id_110')) {
              alert('picked!');
            }
          }

          if (!foundPosition) {
            labelEntity.label.show = false;
          }
        }, Cesium.ScreenSpaceEventType.MOUSE_ClICK);
  },
  methods:{}
}
</script>
